import {
  Component,
  DestroyRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { isUserImpersonating } from '@boldpenguin/sdk';
import { select } from '@ngrx/store';
import { LocalStorageService } from 'ngx-webstorage';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  selectIntercomEnabled,
  selectUserName,
  selectTenantType,
} from 'src/app/core/services/bp-sdk-store-service/bp-sdk-store.selectors';
import { TenantType } from 'src/app/features/settings/models/tenant.model';
import { BpSdkStoreService } from 'src/app/core/services/bp-sdk-store-service/bp-sdk-store.service';
import {
  IntercomInternalLabels,
  IntercomService,
} from 'src/app/core/services/intercom-service/intercom.service';
import { ThemeService } from 'src/app/core/services/theme-service/theme.service';
import { externalUrls, localStorageKeys } from 'src/app/shared/constants';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-top-navigation-toolbar',
  templateUrl: './top-navigation-toolbar.component.html',
  styleUrls: ['./top-navigation-toolbar.component.scss'],
  standalone: false,
})
export class TopNavigationToolbarComponent implements OnInit {
  @Input() suppressNavMenu: boolean;
  @Input() isSideNavOpen = false;
  @Input() isAlertBannerPresent = false;
  @Output() toggleSideNav: EventEmitter<void> = new EventEmitter();

  readonly JiraCreateBugPage = externalUrls.JiraCreateBugPage;
  intercomLabels = IntercomInternalLabels; // For setting the data-intercom-target attribute
  intercomActive = false;
  loggedInUserIsImpersonating = false;
  orderOfSelectedNav = 0;
  nameOfUserBeingImpersonated$: Observable<string>;
  isExchangeTenantType$: Observable<boolean>;
  intercomEnabled$: Observable<boolean>;
  logoPath$: Observable<string>;

  constructor(
    private bpSdkStoreService: BpSdkStoreService,
    private localStorageService: LocalStorageService,
    private intercomService: IntercomService,
    private themeService: ThemeService,
    private destroyRef: DestroyRef,
  ) {}

  ngOnInit(): void {
    this.logoPath$ = this.themeService.getThemeLogoPath$();
    this.nameOfUserBeingImpersonated$ = this.bpSdkStoreService.state$.pipe(
      select(selectUserName),
      map((n) => n ?? ''),
    );

    this.isExchangeTenantType$ = this.bpSdkStoreService.state$.pipe(
      select(selectTenantType),
      map((t) => t === TenantType.Exchange),
    );

    this.bpSdkStoreService.state$
      .pipe(select(isUserImpersonating), takeUntilDestroyed(this.destroyRef))
      .subscribe((isImpersonating: boolean) => {
        if (isImpersonating) {
          this.localStorageService.store(localStorageKeys.impersonated, 'true');
          this.loggedInUserIsImpersonating = true;
        } else if (
          this.localStorageService.retrieve(localStorageKeys.impersonated)
        ) {
          this.loggedInUserIsImpersonating = true;
        }
      });

    this.intercomService.onHide(this.onHideIntercom.bind(this));
    this.intercomService.onShow(this.onShowIntercom.bind(this));

    this.intercomEnabled$ = this.bpSdkStoreService.sdkReadyState$.pipe(
      select(selectIntercomEnabled),
    );
  }

  sideNavClicked() {
    this.toggleSideNav.emit();
  }

  onHideIntercom() {
    this.intercomActive = false;
  }

  onShowIntercom() {
    this.intercomActive = true;
  }
}
